/**
 * 运销列表页面权限
 */
export const YX_SALE_PLAN_LIST_PAGE_UUID =
  '05819ede-dc72-4af7-9a40-15ff8fca8232'

/**
 * 场次相关权限
 */
export const YX_SALE_PLAN_AUCTION_MANAGE_ACTION_UUID =
  'b114758c-0011-403e-bd42-b35623d69a17'
